<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_button_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-button-settings-signal [settings]="settings()" (valueChangeEvent)="onSettingsChange($event)">
    @if (!isForNewUser()) {
        <ng-container class="after-text">
            <div class="form-group mb-20" [class.has-error]="isEmptyEnrollButtonLabel()">
                <label class="col-xs-12">
                    {{ "control_enroll_label" | translate }}
                    <span
                        class="small sp-icon icon-question color-light hover-effect"
                        [tooltip]="enrollButtonLabelTooltip"
                        triggers="mouseover:mouseleave"
                    ></span>
                    <ng-template #enrollButtonLabelTooltip>
                        {{ "control_enroll_signup_tooltip" | translate }}
                    </ng-template>
                </label>
                <div class="col-xs-12">
                    <input
                        class="form-control"
                        [value]="enrollButtonLabel()"
                        (input)="onEnrollLabelChange($any($event.target).value)"
                    />
                    @if (isEmptyEnrollButtonLabel()) {
                        <span class="help-block small">
                            {{ "control_errors_required" | translate }}
                        </span>
                    }
                </div>
            </div>

            <div class="form-group mb-20" [class.has-error]="isEmptyEnterButtonLabel()">
                <label class="col-xs-12">
                    {{ "control_enter_course_label" | translate }}
                    <span
                        class="small sp-icon icon-question color-light hover-effect"
                        [tooltip]="enterButtonLabelTooltip"
                        triggers="mouseover:mouseleave"
                    ></span>
                    <ng-template #enterButtonLabelTooltip>
                        {{ "control_enter_signup_tooltip" | translate }}
                    </ng-template>
                </label>
                <div class="col-xs-12">
                    <input
                        class="form-control"
                        [value]="enterButtonLabel()"
                        (input)="onEnterLabelChange($any($event.target).value)"
                    />
                    @if (isEmptyEnterButtonLabel()) {
                        <span class="help-block small">
                            {{ "control_errors_required" | translate }}
                        </span>
                    }
                </div>
            </div>
        </ng-container>
    }
</sp-form-button-settings-signal>

<web-settings-footer [isSaveDisabled]="isSaveDisabled()" (saveEvent)="onSave()" (cancelEvent)="onReset()" />
